// hooks/useUsuario.ts
import { useState, useEffect } from "react";
import { Usuario } from "../../../interfaces/Usuario";
import { usuarioService } from "../../../services/usuarioService";

export const useUsuario = (
  usuarioId: number | undefined | null,
  fetch: boolean
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [usuario, setUsuario] = useState<Usuario | undefined>(undefined);

  useEffect(() => {
    const fetchUsuario = async () => {
      if (usuarioId && fetch) {
        setIsLoading(true);

        console.log(usuarioId);
        try {
          const data = await usuarioService(usuarioId);
          if (data) {
            setUsuario(data);
          } else {
            console.error("Dados não encontrados para o usuário");
          }
        } catch (error) {
          console.error("Erro ao buscar usuario:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchUsuario();
  }, [usuarioId, fetch]); // Dependência de usuarioId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, usuario };
};
